import { useEffect, useState } from 'react'
import Translation from '../../Translation/cont/Translation'

const ListToggleDisplayWrapper = ({
    className,
    titleTransId,
    defaultIsOpen,
    setAllOpen,
    children
}) => {
    const [isOpen, setIsOpen] = useState(defaultIsOpen)

    const onSetOpen = () => {
        setAllOpen && setAllOpen(null)
        setIsOpen(!isOpen)
    }

    useEffect(() => {
        if(null !== defaultIsOpen && isOpen !== defaultIsOpen) {
            setIsOpen(defaultIsOpen)
        }
    }, [defaultIsOpen])

    return (
        <div className={"program-list " + className}>
            <div className={"program-list-wrapper"  + (isOpen ? ' open' : ' close')} onClick={onSetOpen}>
                <h3 className="title-list text-regular"><Translation id={titleTransId}/></h3>
            </div>

            {isOpen && children}
        </div>
    )
}

export default ListToggleDisplayWrapper